export default __webpack_public_path__ + "static/media/reporting-purpose.eac53e95.png";